<template>
  <EditorPanel :loading-save="loadingSave" @confirm="saveSettings">
    <EditorRowGroup label="Color:">
      <v-select v-model="textOrBackground" :items="textOrBackgroundItems" item-text="name" item-value="value" outlined
        hide-details="auto" dense color="#9BA9BD" class="editor-select--compact rounded-lg m-0 p-0" />
    </EditorRowGroup>

    <div>
      <v-container class="mt-0 mb-2 colors" style="margin-bottom: 4px !important">
        <v-row class="justify-start" v-show="textOrBackground === 'background'">
          <div class="pa-0 py-1 d-flex justify-center">
            <v-tooltip bottom color="#8e84c0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn :style="{ backgroundColor: selectGradientColorWpp.a }" :disabled="loadingSave" class="panelColors"
                  :aria-label="$t('harmony.color-first')" @click="selectGradientWpp = 1" v-bind="attrs" v-on="on" />
              </template>
              <span>{{ $t('harmony.color-first') }}</span>
            </v-tooltip>
            <v-tooltip bottom color="#8e84c0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn :style="{ backgroundColor: selectGradientColorWpp.b }" :disabled="loadingSave" class="panelColors"
                  :aria-label="$t('harmony.color-second')" @click="selectGradientWpp = 2" v-bind="attrs" v-on="on" />
              </template>
              <span>{{ $t('harmony.color-second') }}</span>
            </v-tooltip>
            <v-tooltip bottom color="#8e84c0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn :style="{ backgroundColor: '#e1dcfa' }" :disabled="loadingSave" class="panelColors"
                  :aria-label="$t('harmony.color-direction')" @click="rotateImage" v-bind="attrs" v-on="on">
                  <img src="@/assets/illustrations/arrow.png" class="arrow-icon"
                    :style="{ transform: 'rotate(' + rotationAngle + 'deg)' }" alt="" aria-hidden="true" />
                </v-btn>
              </template>
              <span>{{ $t('harmony.color-direction') }}</span>
            </v-tooltip>
          </div>
        </v-row>
      </v-container>

      <v-color-picker v-model="colorWppComputed" dot-size="25" canvas-height="100" swatches-max-height="200" hide-inputs
        hide-mode-switch @input="updatedGradientWpp" class="remove-preview"
        v-if="selectGradientWpp == 1 || textOrBackground === 'text'"></v-color-picker>

      <v-color-picker v-model="selectGradientColorWpp.b" dot-size="25" hide-inputs hide-mode-switch
        swatches-max-height="200" canvas-height="100" @input="updatedGradientWpp" class="remove-preview"
        v-else-if="selectGradientWpp == 2 && textOrBackground === 'background'"></v-color-picker>

      <v-text-field v-if="textOrBackground === 'text'" v-model="localTextForCard" class="mt-2" label="Texto de la tarjeta"
        color="#8e84c0">
      </v-text-field>
    </div>
  </EditorPanel>
</template>

<script>
import EditorPanel from './EditorPanel.vue'
import EditorRowGroup from './shared/EditorRowGroup.vue'
export default {
  name: 'EditorWppEmailPanel',
  components: { EditorPanel, EditorRowGroup },
  props: {
    siteSetting: {
      type: Object,
      required: true
    },
    loadingSave: {
      type: Boolean,
      default: false
    },
    initialRotationAngle: {
      type: Number,
      default: 90
    }
  },
  data() {
    return {
      textOrBackground: 'text',
      selectGradientWpp: 1,
      selectGradientColorWpp: {
        a: this.siteSetting.wppOrEmail?.background?.color1 || '#FF00FF00',
        b: this.siteSetting.wppOrEmail?.background?.color2 || '#FF00FF00',
        direction: this.siteSetting.wppOrEmail?.background?.direction || 'to top'
      },
      colorTextWpp: this.siteSetting.wppOrEmail?.text?.color || '#000000',
      localTextForCard: this.siteSetting.wppOrEmail?.textForCard || 'Déjame tu correo o WhatsApp, para enviarte un regalito.',
      rotationAngle: this.initialRotationAngle,
      textOrBackgroundItems: [
        { name: 'Texto', value: 'text' },
        { name: 'Fondo', value: 'background' }
      ],
      directions: [
        'to left', 'to left top', 'to top', 'to right top',
        'to right', 'to right bottom', 'to bottom', 'to left bottom'
      ]
    }
  },
  computed: {
    colorWppComputed: {
      get() {
        return this.textOrBackground === 'text' ? this.colorTextWpp : this.selectGradientColorWpp.a
      },
      set(value) {
        if (this.textOrBackground === 'text') {
          this.colorTextWpp = value
        } else {
          this.$set(this.selectGradientColorWpp, 'a', value)
        }
      }
    }
  },
  watch: {
    'siteSetting.wppOrEmail.background': {
      handler(newVal) {
        this.selectGradientColorWpp = {
          a: newVal?.color1 || '#FF00FF00',
          b: newVal?.color2 || '#FF00FF00',
          direction: newVal?.direction || 'to top'
        }
      },
      deep: true
    },
    'siteSetting.wppOrEmail.text.color'(newVal) {
      this.colorTextWpp = newVal || '#000000'
    },
    'siteSetting.wppOrEmail.textForCard'(newVal) {
      this.localTextForCard = newVal || 'Déjame tu correo o WhatsApp, para enviarte un regalito.'
    }
  },
  methods: {
    saveSettings() {
      this.$emit('update:wpp-email', {
        background: {
          direction: this.selectGradientColorWpp.direction,
          color1: this.selectGradientColorWpp.a,
          color2: this.selectGradientColorWpp.b
        },
        text: {
          color: this.colorTextWpp
        },
        textForCard: this.localTextForCard
      })
      this.$emit('save-settings')
    },
    rotateImage() {
      if (this.rotationAngle === 315) {
        this.rotationAngle = 0
      } else {
        this.rotationAngle += 45
      }
      const index = this.rotationAngle / 45
      this.selectGradientColorWpp.direction = this.directions[index]
      this.updatedGradientWpp()
      this.$emit('rotate-image', this.rotationAngle)
    },
    updatedGradientWpp() {
      this.$emit('update:wpp-email', {
        background: {
          direction: this.selectGradientColorWpp.direction,
          color1: this.selectGradientColorWpp.a,
          color2: this.selectGradientColorWpp.b
        },
        text: {
          color: this.colorTextWpp
        },
        textForCard: this.localTextForCard
      })
    }
  }
}
</script>

<style scoped>
@import './editor-panel.css';
</style>
